import React, { useState, useEffect} from 'react';
import Layout from '../components/Layout';
import BannerInner from '../components/BannerInner';
import EnquiryForm from '../components/EnquiryForm';
import { Link } from 'react-router-dom';
import CommonHelmet from '../components/CommonHelmet';
import axios from 'axios';

const Contact = () => {
    const title='Contact Us - 8009340786 | Get Luxury flats in Lucknow';
    const description='Contact us at 8009340786 to get Best Flats/ Apartments in Lucknow. Visit: urbanaidinfratech.com for any queries related to Real Estate like \'Real Estate Company in Lucknow\'.';
    const canonical='/contact';

    const [contactData, setContactData] = useState(null);
    useEffect(() => {
        const fetchContactDetails = async () => {
            try {
                const res = await axios.get('/api/fetchcontactnew', {
                    headers: {
                        Authorization: `${localStorage.getItem("token")}`, // if using JWT
                    }
                });
                if (res.data && res.data.length > 0) {
                    setContactData(res.data[0]);
                }
                console.log(contactData);
            } catch (err) {
                console.error("Failed to fetch contact data:", err);
            }
        };

        fetchContactDetails();
    }, []);

    return (
        <>
            <CommonHelmet title={title} canonical={canonical} description={description} />
            <BannerInner title={'Contact Us'} />
                {contactData?.googlemap && (
                <div
                    className="w-full h-screen flex relative z-0"
                    dangerouslySetInnerHTML={{ __html: contactData.googlemap }}
                />
                )}
            <div className='w-full h-full flex relative z-10 py-10'>
                <div className='container mx-auto'>
                    <div className='grid grid-cols-1 md:grid-cols-2'>
                        <div className='relative flex order-2 md:order-1'>
                            <div className='relative md:absolute md:top-0 md:-mt-[50%] md:left-0 border border-solid border-gray-200 rounded-lg shadow-lg md:shadow-xl overflow-hidden'>
                                <EnquiryForm title={''} />
                            </div>
                        </div>
                        <div className='flex flex-col px-5 md:px-20 pt-10 pb-10 md:pt-16 md:pb-10 order-1 md:order-2'>
                            <h3 className='text-3xl font-semibold text-gray-900 mb-4'>We provide the most suitable and quality real estate.</h3>
                            <span className='text-base'>We’d love to hear from you. We are here to answer any question you may have.</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className='w-full h-full flex relative z-10 py-8'>
                <div className='container mx-auto'>
                    <div className='flex flex-col justify-center text-center gap-6'>
                        <h3 className='text-3xl font-semibold text-gray-900'>Site Address</h3>
                        <div className='grid grid-cols-1 md:grid-cols-3 gap-10'>
                            <div className='w-full shadow-lg px-4 py-4 flex flex-col justify-start items-center bg-white border border-solid border-gray-200'>
                                <div className='text-xl font-semibold mb-2 text-gray-800'>India Green City</div>
                                <p>Sadrauna, Munnu Khera, Para, Alambagh, Lucknow</p>
                            </div>
                            <div className='w-full shadow-lg px-4 py-4 flex flex-col justify-start items-center bg-white border border-solid border-gray-200'>
                                <div className='text-xl font-semibold mb-2 text-gray-800'>Taj Enclave</div>
                                <p>Kathingra, Agra- Lucknow Expressway. Lucknow</p>
                            </div>
                            <div className='w-full shadow-lg px-4 py-4 flex flex-col justify-start items-center bg-white border border-solid border-gray-200'>
                                <div className='text-xl font-semibold mb-2 text-gray-800'>Urbanaid Uniworld</div>
                                <p>Faizabad Road, Opposite Golden Blossom Resort, Near by Ifact Academy, Juggaur Station Road, Lucknow</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='w-full h-full flex relative z-10 py-8'>
                <div className='container mx-auto'>
                    <div className='flex flex-col justify-center text-center gap-6'>
                        <h3 className='text-3xl font-semibold text-gray-900'>Office Address</h3>
                        <div className='w-full md:w-1/2 mx-auto'>{contactData?.officeaddress || 'Loading...'}</div>
                        <div className='grid grid-cols-1 md:grid-cols-3 gap-10'>
                            <div className='w-full shadow-lg px-4 py-4 flex flex-col justify-center bg-white items-center border border-solid border-gray-200 font-semibold'>
                                {contactData?.mobile?.map((mobile, idx) => (
                                    <p key={idx}>+91-{mobile}</p>
                                ))}
                                {contactData?.landline?.map((landline, idx) => (
                                    <p key={idx}>0522-{landline}</p>
                                ))}
                            </div>
                            <div className='w-full shadow-lg px-4 py-4 flex flex-col justify-center items-center bg-white border border-solid border-gray-200'>
                                {contactData?.email?.map((email, idx) => (
                                    <Link key={idx} to={`mailto:${email}`} className='hover:text-orange-500 font-semibold'>{email}</Link>
                                ))}
                            </div>
                            <div className='w-full shadow-lg px-4 py-4 flex flex-col justify-center items-center bg-white border border-solid border-gray-200'>
                                
                                <Link to={contactData?.website || 'urbanaidinfratech.com'} className='hover:text-orange-500 font-semibold'>{contactData?.website || 'urbanaidinfratech.com'}</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Contact;